const React = require('react')
const PropTypes = require('prop-types')

class MatchMedia extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = { matches: false }

    this.updateMatches = this.updateMatches.bind(this)
  }

  componentDidMount() {
    this.addMediaQueryListener()
  }

  componentWillUnmount() {
    this.removeMediaQueryListener()
  }

  addMediaQueryListener() {
    if (typeof window === 'object' && window.matchMedia) {
      this.mediaQueryList = window.matchMedia(this.props.query)
      this.mediaQueryList.addListener(this.updateMatches)
      this.updateMatches()
    }
  }

  removeMediaQueryListener() {
    if (this.mediaQueryList) {
      this.mediaQueryList.removeListener(this.updateMatches)
    }
  }

  updateMatches() {
    if (this.mediaQueryList) {
      this.setState({
        matches: this.mediaQueryList.matches
      })
    }
  }

  render() {
    return this.state.matches ? this.props.children : null
  }
}

MatchMedia.propTypes = {
  query: PropTypes.string.isRequired,
  children: PropTypes.node
}

module.exports = MatchMedia
